import { namespace } from '@common/Utils';
import { type IConfig } from '@interface/ICommon';
import { AppInit } from './appInit';
import Main, { loader } from './itemdic/Main';

namespace('window.nc.info.itemdict');
window.nc.info.itemdict = (config: IConfig) => {
    config.now = 'itemdict';
    AppInit('.itemdict-container', config, Main, loader);
};
